import angular from 'angular';
import 'angular-bootstrap';
import '../../common/components/locale';
// Import for side effects only (to ensure the module is loaded)
import './formsServices';

const formsControllers = angular.module('applicationModule.formsControllers', ['applicationModule.formsServices', 'ui.bootstrap']);

// Form List Controller
formsControllers.controller('FormsController', ['$scope', '$rootScope', '$stateParams', 'NgTableParams', 'Forms', 'growl', 'AppsoupAPI', 'Permissions', '$state', '$modal', function ($scope, $rootScope, $stateParams, NgTableParams, Forms, growl, AppsoupAPI, Permissions, $state, $modal) {
    'use strict';
    $rootScope.$broadcast('newApp', {select: $stateParams.application_id});
    $scope.writeAccess = Permissions.hasWriteAccess('forms');
    $scope.app_id = $stateParams.application_id;

    $scope.tableParams = new NgTableParams(AppsoupAPI.getDefaultTableParams(), {
        getData: function (params) {
            $scope.isLoading = true;
            return Forms.getList($scope.app_id, params._params)
                .then(function (response) {
                    params.total(response.forms.total);
                    params.count(response.forms.per_page);
                    params.page(response.forms.current_page);
                    return response.forms.data;
                }).finally(function () {
                    $scope.isLoading = false;
                });
        },
        counts: AppsoupAPI.getDefaultCounts()
    });

    $scope.newForm = function () {
        var modalInstance = $modal.open({
            templateUrl: 'views/application/forms/form.tpl.html',
            controller: 'FormModalController',
            resolve: {
                form: function () {
                    return {
                        app_id: $scope.app_id
                    };
                }
            }
        });
        modalInstance.result.then(function (form) {
            $scope.tableParams.data.push(form);
            growl.success('MODULES.FORMS.SUCCESS.CREATED');
        }).catch(() => {});
    };

    $scope.editForm = function (data, index) {
        var modalInstance = $modal.open({
            templateUrl: 'views/application/forms/form.tpl.html',
            controller: 'FormModalController',
            resolve: {
                form: function () {
                    return data;
                }
            }
        });
        modalInstance.result.then(function (form) {
            $scope.tableParams.data[index] = form;
            growl.success('MODULES.FORMS.SUCCESS.CREATED');
        }).catch(() => {});
    };

    $scope.remove = function ($event) {
        $event.stopImmediatePropagation();
    };

    $scope.removeForm = function (id, index) {
        Forms.remove(id, $scope.app_id)
            .then(function (response) {
                const data = response.data;
                if (data.success) {
                    growl.success('MODULES.FORMS.SUCCESS.DELETED');
                    $scope.tableParams.data.splice(index, 1);
                } else {
                    growl.error('MODULES.FORMS.ERROR.DELETED');
                }
            });
    };

    $scope.searchForms = function (search) {
        var find = angular.copy(search);
        angular.extend($scope.tableParams._params, find);
    };

    $scope.clearSearch = function () {
        $scope.search = {};
        if (angular.isDefined($scope.tableParams._params.name)) {
            $scope.tableParams._params.name = undefined;
        }
    };

    $scope.generateCSV = function (formId) {
        $scope.isLoadingExport = true;
        Forms.generateCSV($scope.app_id, formId)
            .then(function (response) {
                const data = response.data;
                if (angular.isDefined(data.error)) {
                    growl.error(data.error);
                } else if (data) {
                    angular.openInNewTab(data);
                } else {
                    growl.error(data.error);
                }
            }).finally(function () {
            $scope.isLoadingExport = false;
        });
    };

    $scope.copyForms = function (id) {
        Forms.copy(id).then(function (response) {
            const data = response.data;
            if (data.success) {
                growl.success('MODULES.FORMS.SUCCESS.COPY_FORMS');
                $state.go($state.current, {searchForms: $stateParams.searchForms}, {reload: true});
            } else if (data.error === 'ERROR.FORM_NOT_EXISTS') {
                growl.error('ERROR.FORM_NOT_EXISTS');
            } else {
                growl.error('MODULES.FORMS.ERROR.COPY_FORMS');
            }
        });
    };
}]);

// Form Modal Controller
formsControllers.controller('FormModalController', ['$scope', '$state', '$stateParams', '$modalInstance', 'growl', 'Forms', 'form', function ($scope, $state, $stateParams, $modalInstance, growl, Forms, form) {
    'use strict';
    var appId = $stateParams.application_id;
    $scope.form = {};
    $scope.form.app_id = appId;
    $scope.editMode = false;

    if (form.name) {
        $scope.editMode = true;
        $scope.form = angular.copy(form);
    }

    $scope.ok = function () {
        $scope.$broadcast('show-errors-check-validity');
        $scope.isLoading = true;

        Forms.save($scope.form, $scope.editMode)
            .then(function (response) {
                const data = response.data;
                if (data.success) {
                    $modalInstance.close(data.form);
                } else {
                    if (typeof data.error === 'object') {
                        $scope.formErrors = data.error;
                    } else {
                        growl.error('MODULES.FORMS.ERROR.CREATED');
                    }
                }
            })
            .finally(function () {
                $scope.isLoading = false;
            });
    };

    $scope.cancel = function () {
        $modalInstance.dismiss('cancel');
    };

    $scope.remove = function () {
        $modalInstance.dismiss('cancel');
    };

    $scope.inputErrors = {
        'name': [{type: '$invalid', msg: 'ERROR.REQUIRE.NAME'}]
    };
}]);

// Form Elements List Controller
formsControllers.controller('FormElementsController', ['$scope', '$rootScope', '$stateParams', 'NgTableParams', 'FormElements', 'growl', 'AppsoupAPI', 'Permissions', '$state', '$modal', function ($scope, $rootScope, $stateParams, NgTableParams, FormElements, growl, AppsoupAPI, Permissions, $state, $modal) {
    'use strict';
    $rootScope.$broadcast('newApp', {select: $stateParams.application_id});
    $scope.writeAccess = Permissions.hasWriteAccess('forms');
    $scope.app_id = $stateParams.application_id;
    $scope.form_id = $stateParams.formId;

    $scope.tableParams = new NgTableParams(AppsoupAPI.getTitleTableParams(), {
        getData: function (params) {
            $scope.isLoading = true;
            return FormElements.getList($scope.app_id, $scope.form_id, params._params)
                .then(function (response) {
                    params.total(response.elements.total);
                    params.count(response.elements.per_page);
                    params.page(response.elements.current_page);
                    return response.elements.data;
                }).finally(function () {
                    $scope.isLoading = false;
                });
        },
        counts: AppsoupAPI.getDefaultCounts()
    });

    $scope.newElement = function () {
        var modalInstance = $modal.open({
            templateUrl: 'views/application/forms/element.tpl.html',
            controller: 'FormElementModalController',
            resolve: {
                element: function () {
                    return {
                        app_id: $scope.application_id,
                        form_id: $scope.form_id
                    };
                }
            }
        });
        modalInstance.result.then(function (element) {
            $scope.tableParams.data.push(element);
            growl.success('MODULES.FORMS.ELEMENTS.SUCCESS.CREATED');
        }).catch(() => {});
    };

    $scope.editElement = function (data, index) {
        var modalInstance = $modal.open({
            templateUrl: 'views/application/forms/element.tpl.html',
            controller: 'FormElementModalController',
            resolve: {
                element: function () {
                    return data;
                }
            }
        });
        modalInstance.result.then(function (element) {
            $scope.tableParams.data[index] = element;
            growl.success('MODULES.FORMS.ELEMENTS.SUCCESS.CREATED');
        }).catch(() => {});
    };

    $scope.remove = function ($event) {
        $event.stopImmediatePropagation();
    };

    $scope.removeElement = function (id, index) {
        FormElements.remove(id, $scope.app_id)
            .then(function (result) {
                let data = result.data;

                if (data.success) {
                    growl.success('MODULES.FORMS.ELEMENTS.SUCCESS.DELETED');
                    $scope.tableParams.data.splice(index, 1);
                } else {
                    growl.error('MODULES.FORMS.ELEMENTS.ERROR.DELETED');
                }
            });
    };

    $scope.changeOrder = function ($event, key1, key2) {
        var data = $scope.tableParams.data;
        $event.stopImmediatePropagation();
        FormElements.changeOrder({
            order_ids: [$scope.tableParams.data[key1].order, $scope.tableParams.data[key2].order],
            app_id: $scope.app_id
        })
            .then(function (response) {
                if (response.data.success) {
                    data = angular.changeOrderResponse(data, key1, key2);
                }
            });
        $scope.tableParams.data = data;
    };

}]);

// Form Element Modal Controller
formsControllers.controller('FormElementModalController', ['$scope', '$state', '$stateParams', '$modalInstance', 'growl', 'FormElements', 'element', function ($scope, $state, $stateParams, $modalInstance, growl, FormElements, element) {
    'use strict';
    var appId = $stateParams.application_id;
    $scope.element = {};
    $scope.element.app_id = appId;
    $scope.element.form_id = element.form_id;
    $scope.editMode = false;

    if (element.title) {
        $scope.editMode = true;
        $scope.element = angular.copy(element);
        if ($scope.element.url) {
            $scope.fileUploaded = true;
        }
    }

    $scope.generateName = function () {
        if ($scope.element.title && !$scope.editMode) {
            var dict = {'ą': 'a', 'ę': 'e', 'ć': 'c', 'ł': 'l', 'ń': 'n', 'ó': 'o', 'ś': 's', 'ż': 'z', 'ź': 'z'};
            var str = angular.copy($scope.element.title);
            str = str.replace(/\s+/g, '_').toLowerCase();
            str = str.replace(/[^\w ]/g, function (char) {
                return dict[char] || char;
            });
            str = str.replace(/[^0-9a-z-]+/g, '');
            str = str.replace(/[-]+/g, '_');
            $scope.element.name = str;
        }
    };

    $scope.elementType = [
        'checkbox',
        'color',
        'date',
        'email',
        'hidden',
        'number',
        'password',
        'radio',
        'range',
        'tel',
        'text',
        'textarea',
        'url',
        'button',
        'link',
        'label'
    ];


    $scope.ok = function () {
        $scope.$broadcast('show-errors-check-validity');
        $scope.isLoading = true;

        FormElements.save($scope.element, $scope.editMode)
            .then(function (result) {
                let data = result.data;

                if (data.success) {
                    $modalInstance.close(data.element);
                } else {
                    if (typeof data.error === 'object') {
                        $scope.formErrors = data.error;
                    } else {
                        growl.error('MODULES.FORMS.ELEMENTS.ERROR.CREATED');
                    }
                }
            })
            .finally(function () {
                $scope.isLoading = false;
            });
    };

    $scope.cancel = function () {
        $modalInstance.dismiss('cancel');
    };

    $scope.remove = function () {
        $modalInstance.dismiss('cancel');
    };

    $scope.inputErrors = {
        'title': [{type: '$invalid', msg: 'ERROR.REQUIRE.TITLE'}],
        'type': [{type: '$invalid', msg: 'ERROR.REQUIRE.TYPE'}]
    };
}]);

export default formsControllers;
